export default __webpack_public_path__ + "static/media/logo-economicForum.0daf3552.svg";